import { Uuid } from "@/domains/global/identifiers";
import { CacheKey } from "@/modules/cache/constants";
import { GLOBAL_CACHE_INSTANCE, LEGACY_GLOBAL_CACHE_INSTANCE } from "@/modules/cache/globalCache";
import { uuidModule } from "@/modules/uuid";

/**
 * Generated per-client-group (per-user).
 * Should be cleared on logout.
 */
export const clientEnvClientGroupId = async (): Promise<{ clientGroupId: Uuid }> => {
  const activeClientGroup = await GLOBAL_CACHE_INSTANCE.get(CacheKey.ActiveClientInfo);

  if (activeClientGroup?.clientGroupId) {
    return { clientGroupId: activeClientGroup.clientGroupId };
  }

  const legacyClientGroup = await LEGACY_GLOBAL_CACHE_INSTANCE.get(CacheKey.ActiveClientInfo);

  if (legacyClientGroup?.clientGroupId) {
    await GLOBAL_CACHE_INSTANCE.set(CacheKey.ActiveClientInfo, {
      clientGroupId: legacyClientGroup.clientGroupId,
    });

    // Clear legacy cache after migration
    await LEGACY_GLOBAL_CACHE_INSTANCE.del(CacheKey.ActiveClientInfo);

    return { clientGroupId: legacyClientGroup.clientGroupId };
  }

  const newClientGroupId = uuidModule.generate();

  await GLOBAL_CACHE_INSTANCE.set(CacheKey.ActiveClientInfo, { clientGroupId: newClientGroupId });

  return { clientGroupId: newClientGroupId };
};

export const clearClientEnvClientGroupId = async (): Promise<void> => {
  await GLOBAL_CACHE_INSTANCE.del(CacheKey.ActiveClientInfo);
};
